import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { hsaMerchantClassificationProjection } from "./hsa-merchant-classification";

/** One approved MCC as the reviewer sees it: what the code means and when to choose it. */
export const hsaMccCatalogEntry = z.object({
  mcc: z.string(),
  description: z.string(),
  rule: z.string().nullable(),
  industryCode: z.string(),
  tier: z.string(),
});

/** The team's merchant classification, or null before the first run, and the approved MCCs to pick from. */
export const getHsaMerchantClassification = {
  name: "getHsaMerchantClassification" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    classification: hsaMerchantClassificationProjection.nullable(),
    mccCatalog: z.array(hsaMccCatalogEntry),
  }),
};
